// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--3DKdT","buttonHero":"Button-module--buttonHero--2xs9r"};